var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.476 3.66602H7.52409C5.0295 3.66602 3 5.69552 3 8.19011C3 10.6968 5.0506 12.7142 7.49711 12.7142H9.5291V9.16954C9.5291 7.5821 10.8205 6.29063 12.4079 6.29063H12.4142C13.9982 6.29403 15.2869 7.5855 15.2869 9.16954V12.7142H20.476C22.9705 12.7142 25 10.6847 25 8.19011C25 5.69552 22.9705 3.66602 20.476 3.66602ZM21.7562 7.55924L19.178 10.1374C18.9264 10.3891 18.5183 10.3891 18.2665 10.1374L16.9775 8.84831C16.7258 8.59659 16.7258 8.18852 16.9775 7.93681C17.2291 7.6851 17.6373 7.6851 17.889 7.93681L18.7223 8.7701L20.8447 6.64775C21.0964 6.39604 21.5045 6.39604 21.7562 6.64775C22.0079 6.89946 22.0079 7.30757 21.7562 7.55924Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1471 14.5281L13.9979 14.0968V9.1695C13.9979 8.29276 13.2882 7.58155 12.4114 7.57965C11.5321 7.57776 10.8182 8.2901 10.8182 9.1695V17.416H10.8038L9.23441 16.1055C8.57247 15.5527 7.58471 15.6564 7.0519 16.3345C6.54096 16.9847 6.63961 17.9234 7.27456 18.4532L10.46 21.1113H19.8416V16.4468C19.8416 15.4713 19.115 14.6487 18.1471 14.5281Z",
    fill: "var(--ion-color-secondary)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8182 23.6895C10.8182 24.0454 11.1068 24.334 11.4628 24.334H19.1971C19.5531 24.334 19.8417 24.0454 19.8417 23.6895V22.4004H10.8182V23.6895Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.ab57cc46.svg";
export { ForwardRef as ReactComponent };